<template lang="html">
  <v-card class="elevation-0 pa-2 flex-column" outlined>
    <v-row no-gutters>
      <label style="font-weight: bold;"> {{ $t('title.coligadas') }} </label>
    </v-row>
    <v-row no-gutters>
      <v-chip  class="mr-2 my-2 rounded" :color="infoTenants[tenant].color" style="color: white;" v-for="tenant in tenants" :key="tenant">
        {{ infoTenants[tenant].name }}
      </v-chip>
    </v-row>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TenantUsuarioLogadoList',
  props: {
    tenants: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters('implantacao', [
      'chaveEmpresa',
    ]),
    ...mapGetters('usuario', [
      'usuarioLogado',
    ]),
  },
  data() {
    return {
      tenantsUsuario: [],
      usuarioResource: this.$api.usuario(this.$resource),
      infoTenants: {
        epoca: {
          name: 'Época',
          color: '#f05a8c',
        },
        kabum: {
          name: 'Kabum',
          color: '#ff6500',
        },
        magalu: {
          name: 'Magalu',
          color: '#0086ff',
        },
      },
    };
  },
  methods: {
  },
  mounted() {
  },
};
</script>
